import Typography from '@mui/material/Typography';
import { useColorScheme, useTheme } from '@mui/material/styles';

import { ThemeMode } from 'config';

export default function Logo({ dark = false }: { dark?: boolean }) {
  const theme = useTheme();
  const { colorScheme } = useColorScheme();
  const isDark = colorScheme === ThemeMode.DARK || dark;

  return (
    <Typography
      variant="h5"
      component="span"
      sx={{
        fontWeight: 400,
        letterSpacing: '0.02em',
        fontSize: '1.75rem',
        textDecoration: 'none',
        color: isDark ? theme.vars.palette.common.white : theme.vars.palette.grey[900],
        '& span': {
          color: isDark ? theme.vars.palette.secondary[200] : theme.vars.palette.secondary.main,
        },
      }}
    >
      READY<span>2</span>MICE
    </Typography>
  );
}
